import "./serviceState.scss";

const ServiceState = ({
  Servicesone = 0,
  Servicestwo = 0,
  Servicesthree = 0,
  Servicesfour = 0,

  TextServicesone = "متن",
  TextServicestwo = "متن",
  TextServicesthree = "متن",
  TextServicesfour = "متن",
}) => {
  // Statistic data received from the parent component
  // دریافت اطلاعات آماری از کامپوننت والد
  const stats = [
    {
      id: "weekly",
      title: TextServicesone,
      value: Servicesone,
    },
    {
      id: "monthly",
      title: TextServicestwo,
      value: Servicestwo,
    },
    {
      id: "customers",
      title: TextServicesthree,
      value: Servicesthree,
    },
    {
      id: "completed",
      title: TextServicesfour,
      value: Servicesfour,
    },
  ];

  return (
    <section className="service-stats">
      <div className="service-stats__grid">
        {stats.map((stat) => (
          <article className="service-stats__card" key={stat.id}>
            <h3 className="service-stats__title">{stat.title}</h3>

            <span className="service-stats__value">{stat.value}</span>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ServiceState;
